import React from 'react'
import "../Loder/UniLoder.css"
export const UniLoder = () => {
  return (
    <div className='main-uniloder'>

<span class="loader"></span>
    </div>
  )
}
